export enum ConfirmationType {
  UNSAVED_CHANGES = 'UNSAVED_CHANGES',
  UNSAVED_CHANGES_WITH_PHOTOS = 'UNSAVED_CHANGES_WITH_PHOTOS',
  PENDING_UPLOADS = 'PENDING_UPLOADS',
  UNSAVED_CHANGES_TAB_SWITCH = 'UNSAVED_CHANGES_TAB_SWITCH',
}

export interface ConfirmationConfig {
  shouldConfirm: boolean;
  onConfirm?: () => void;
  onSave?: () => void | Promise<void>;
  confirmationType: ConfirmationType;
}
